import { Drawer } from "antd";
import close from "./../../../../assets/images/close.svg";

const ConfirmationPopup = ({ show, closePopup, handleConfirmation }: any) => {
  return (
    <Drawer
      placement="bottom"
      onClose={closePopup}
      closeIcon={false}
      open={show}
      height="auto"
      className="rounded-t-2xl overflow-hidden max-w-[450px] mx-auto"
      style={{ margin: "auto" }}
      push={false}
    >
      <div className="flex flex-col h-full">
        <div className="flex justify-between items-center">
          <div className="font-semibold text-lg">
            Are you sure you want to quit?
          </div>
          <img
            src={close}
            alt="close"
            className="cursor-pointer"
            onClick={closePopup}
          />
        </div>
      </div>
      <div className="text-sm pt-3 pb-2">
        If you quit, all progress in this session will be lost and you’ll need
        to start over
      </div>
      <section className="flex justify-center gap-5 mt-6 text-base font-medium tracking-normal leading-loose text-center w-full">
        <button
          className={`overflow-hidden gap-2 self-stretch px-14 py-2 text-indigo-600 bg-white whitespace-nowrap rounded-xl border border-indigo-600 border-solid flex justify-center`}
          aria-label={"Yes, Quit"}
          onClick={handleConfirmation}
        >
          Yes, Quit
        </button>
        <button
          className={`overflow-hidden gap-2 self-stretch px-14 py-2 text-white bg-indigo-600 whitespace-nowrap rounded-xl border border-indigo-600 border-solid flex justify-center`}
          aria-label={"No, Stay"}
          onClick={closePopup}
        >
          No, Stay
        </button>
      </section>
    </Drawer>
  );
};

export default ConfirmationPopup;
